import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import PanelRightIcon from '@atlaskit/icon/core/panel-right';

import { PARENT_PRODUCTS } from '@atlassian/confluence-page-preview-panel/constants';
import { useConfluencePagePreviewPanel } from '@atlassian/confluence-page-preview-panel/ui';
import { useIsPreviewPanelOpen } from '@atlassian/preview-panels-api/use-is-preview-panel-open';

import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export const PreviewPanelTestButton = (): React.JSX.Element | null => {
	const previewPanelUrl = StatsigConfigurations.getString(
		'confluence_page_preview_panel_testing',
		'',
	);

	const { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel } =
		useConfluencePagePreviewPanel(PARENT_PRODUCTS.CONFLUENCE);
	const isOpen = useIsPreviewPanelOpen();

	if (!previewPanelUrl) {
		return null;
	}

	return (
		<IconButton
			icon={PanelRightIcon}
			label="Preview Panel Test"
			onClick={() =>
				isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel(previewPanelUrl)
			}
		/>
	);
};
